import PropTypes from 'prop-types';

import styles from 'styles/components/common/searchField.scss';
import { TextField } from 'components/Mdl';

const SearchField = ({ name, placeholder = '', value = '', onChange, type = 'text', id }, { testId }) => (
  <div className={styles.searchField}>
    <TextField
      className={styles.searchTextField}
      name={name}
      placeholder={placeholder}
      type={type}
      id={id}
      data-test-id={testId('searchTextField')}
      value={value}
      onChange={onChange} />
  </div>
);

SearchField.contextTypes = {
  testId: PropTypes.func.isRequired
};

SearchField.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default SearchField;
